import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// axios
import axios from 'axios'
Vue.prototype.$http = axios
Vue.prototype.CancelToken = axios.CancelToken;

// Session
import VueSession from 'vue-session'
var options = {
  persist: true
}
Vue.use(VueSession, options)

// Custom Loading Spinner Component

import LoadingSpinner from '@/components/LoadingSpinner.vue'
Vue.component("loading-spinner", LoadingSpinner);

import DefaultLayout from "@/layouts/DefaultLayout.vue";
Vue.component("default-layout", DefaultLayout);

import BlankLayout from "@/layouts/BlankLayout.vue";
Vue.component("blank-layout", BlankLayout);

import OverlayLoadingProgress from '@/components/OverlayLoadingProgress.vue';
Vue.component("overlay-loading-progress", OverlayLoadingProgress);

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
